import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VModal from 'vue-js-modal'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/web/css/element-ui.scss'
import FullPageModal from 'vue-fullpage-modal'
import resize from 'vue-element-resize-detector'
import globals from '@/global'
import VueGtag from 'vue-gtag'

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtag, {
    config: {
      id: 'G-51ST3NH3D9'
    }
  }, router)
}

Vue.use(ElementUI, { locale })
Vue.use(FullPageModal)
Vue.use(VModal)
Vue.use(resize)
Vue.use(globals)

Vue.config.productionTip = false

const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.app = vm
